export const estimateSubscribedContact = {
  'estimate_subscribed_contact.page_title': 'Získejte přesný odhad',
  'estimate_subscribed_contact.title':
    'Pro získání přesného odhadu vyplňte kontaktní údaje',
  'estimate_subscribed_contact.subtitle':
    'Zjistěte nezávazně a zdarma přesný odhad ceny nemovitosti a jak nejlépe prodat.',

  'estimate_subscribed_contact.label.name': 'Jméno a příjmení',
  'estimate_subscribed_contact.label.phone': 'Telefon',

  'estimate_subscribed_contact.button.submit': 'Získat přesný odhad ZDARMA',

  'estimate_subscribed_contact.gdpr':
    'Odesláním formuláře souhlasím s <terms>obchodními podmínkami</terms> a se <gdpr>zpracováním osobních údajů</gdpr>.',

  'estimate_subscribed_contact.error.fullName': 'Vyplňte prosím jméno',
  'estimate_subscribed_contact.error.phone':
    'Vyplňte prosím platný telefon (např. ve tvaru 777888999, nebo +420 777 888 999)',
  'estimate_subscribed_contact.error.submit':
    'Při odesílání formuláře došlo k chybě, zkuste to prosím později.',
};
